// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://sealegveagancceevrls.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNlYWxlZ3ZlYWdhbmNjZWV2cmxzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI3NTExNjEsImV4cCI6MjA1ODMyNzE2MX0.DV6WLOT-Uips2SxJCKzUifp_nyaaVj0Uk1TWVgdCoHg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);